import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import localize, { LocKeys } from "../../constants/localizations";
import CustomSnackbar from "../../shared/CustomSnackbar/CustomSnackbar";
import { clearLodSpecificationRequestState } from "../../actions";
import { alertTypeConstants } from "../../constants/constants";

/**
 * Snackbars for LOD specification (success, error)
 * @param {*} props
 * @returns
 */
const LodSpecRequestPopups = (props) => {
	const {
		customSuccessMessage = "",
		customErrorMessage = "",
		// Actions
		clearLodSpecificationRequestState,
		// From state
		request,
		action,
		errorMessage,
		successMessage,
	} = props;

	const [showError, setShowError] = useState(!action && request);
	const [showSuccess, setShowSuccess] = useState(action && request);

	useEffect(() => {
		if (request) {
			if (!action) {
				setShowError(true);
			} else {
				setShowSuccess(true);
			}
		}
	}, [action, request]);

	const errorOnClose = () => {
		setShowError(false);
		clearLodSpecificationRequestState();
	};

	const successOnClose = () => {
		setShowSuccess(false);
		clearLodSpecificationRequestState();
	};

	return (
		<>
			<CustomSnackbar
				open={showSuccess}
				onClose={successOnClose}
				title={localize(LocKeys.SUCCESS)}
			>
				{successMessage || customSuccessMessage}
			</CustomSnackbar>
			<CustomSnackbar
				open={showError}
				onClose={errorOnClose}
				type={alertTypeConstants.ERROR}
				title={localize(LocKeys.ERROR)}
			>
				{errorMessage || customErrorMessage}
			</CustomSnackbar>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		action: state.getIn(["lodSpecification", "action"]),
		request: state.getIn(["lodSpecification", "request"]),
		errorMessage: state.getIn(["lodSpecification", "errorMessage"]),
		successMessage: state.getIn(["lodSpecification", "successMessage"]),
	};
};
export default connect(mapStateToProps, {
	clearLodSpecificationRequestState,
})(LodSpecRequestPopups);
